import React from "react";
import "./index.scss";
import SelectBox from "devextreme-react/select-box";
import { IMdaeSelectBoxProps } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";
import { RequiredFieldLabel } from "../required-field-label";

const MdaeSelectBox: React.FC<IMdaeSelectBoxProps> = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  return (
    <div className="sys-mdae-select-box-container">
      <SelectBox
        {...props}
        ref={ref}
        searchEnabled={true}
        showClearButton={false}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_SELECT_BOX,
            e.component,
            dispatch
          );
        }}
      />
      {props.visible !== false && (
        <span className={`mdae-text-box-field-set-text ${props.madeFieldTitleClassName}`}>       
          {typeof props.mdaeDropDownBoxTitle === "string" ? props.mdaeDropDownBoxTitle : null}
          {/* {props.mdaeDropDownBoxTitle} */}
          {props.required && typeof props.mdaeDropDownBoxTitle === "string" && <RequiredFieldLabel />}
          {typeof props.mdaeDropDownBoxTitle === "function"?props.mdaeDropDownBoxTitle() : null}
        </span>
      )}
    </div>
  );
});
export default MdaeSelectBox;
